import Push from "./Push";

export { default as PushFragment } from "./PushFragment.gql";
export default Push;
